import { render, staticRenderFns } from "./UploadCardDetail.vue?vue&type=template&id=5ecc21b6&scoped=true&"
import script from "./UploadCardDetail.vue?vue&type=script&lang=js&"
export * from "./UploadCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./UploadCardDetail.vue?vue&type=style&index=0&id=5ecc21b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc21b6",
  null
  
)

export default component.exports